module.exports = __webpack_public_path__ + "static/media/445.a84fc25a.png";